<template>
  <div  ref="tpane" class="transitionable noflow" :class="{slow: slow}">
    <slot></slot>
  </div>
</template>

<script>
import { setTimeout } from 'timers';
export default {
  props: {
    activated: Boolean,
    delay: {
      type: Number,
      default: 0
    },
    slow: Boolean,
    collapse: Boolean,
    updateData: Object
  },
  data: function () {
    return {
      height: 0,
      fullHeight: -1,
      intrans: false
    }
    
  },
  mounted: function () {
    this.remeasure()
  },
  methods:{
    remeasure: function () {

      if(!this.collapse) {
        this.$refs.tpane.style.height = 'auto'
        this.height  = this.$refs.tpane.offsetHeight
      }
      this.$refs.tpane.style.height = this.height + 'px'
    },
    handleActivate: function () {
      if(this.fullHeight === -1){
        this.intrans = false
        this.$refs.tpane.classList.remove('transitionable')
        this.$refs.tpane.style.height = 'auto'
        this.$refs.tpane.offsetHeight // this is really important, weirdly
        this.$nextTick(() => {
          
          this.fullHeight = this.$refs.tpane.offsetHeight
          this.$refs.tpane.style.height = this.height + 'px'
          this.$refs.tpane.offsetHeight // this is really important, weirdly
          this.$refs.tpane.classList.add('transitionable')
          this.intrans = true
          this.$refs.tpane.style.height = this.fullHeight + 'px'
        })
        
      }
      else {
        this.$nextTick(() => {
          this.$refs.tpane.style.height = this.fullHeight + 'px'
        })
      }
      
      
    },
    handleDeactivate: function () {
      this.$refs.tpane.style.height = this.height + 'px'
    }
  },
  watch: {
    activated: function () {
      const vm = this
      this.$nextTick(function () {
        
        if(vm.activated) {
          if(this.delay === 0) {
            vm.handleActivate()
          }
          else {
            setTimeout(() => { vm.handleActivate() }, vm.delay)
          }
        }
        else {

          vm.handleDeactivate()
        }
      })
      
    },
    updateData: function () {
      this.$nextTick(() => {
        this.remeasure()
      })
      
    }
  }
}
</script>

<style>
  .transitionable{
    transition: all 0.15s ease;
  }

  .transitionable.slow
  {
    transition: all 0.6s ease;
  }

  .noflow{
    overflow:hidden;
    width:100%;
  }
  

</style>
